import React from 'react';
import styled from 'styled-components';
import { colors } from '../../styles/colors';
import i18n from '../../i18n';

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 20px;
  background: linear-gradient(135deg, rgba(245, 247, 250, 1) 0%, rgba(195, 207, 226, 1) 100%);
`;

const ErrorBox = styled.div`
  background: var(--ucp-bg-card);
  border-radius: 12px;
  padding: 40px;
  max-width: 600px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  text-align: center;
`;

const ErrorIcon = styled.div`
  font-size: 64px;
  margin-bottom: 20px;
`;

const ErrorTitle = styled.h1`
  color: rgba(211, 47, 47, 1);
  font-size: 24px;
  margin-bottom: 16px;
`;

const ErrorMessage = styled.p`
  color: colors.textSecondary;
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 24px;
`;

const ErrorDetails = styled.pre`
  background: colors.background;
  padding: 16px;
  border-radius: 8px;
  font-size: 12px;
  text-align: left;
  overflow-x: auto;
  color: colors.text;
  margin-bottom: 24px;
`;

const ReloadButton = styled.button`
  background: linear-gradient(135deg, ${({ theme }) => theme.colors.primaryBlue} 0%, ${({ theme }) => theme.colors.buttonPrimaryDark} 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log l'erreur pour le débogage
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({
      error,
      errorInfo
    });
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <ErrorContainer>
          <ErrorBox>
            <ErrorIcon>⚠️</ErrorIcon>
            <ErrorTitle>{i18n.t('errorBoundary.title')}</ErrorTitle>
            <ErrorMessage>
              {i18n.t('errorBoundary.message')}
            </ErrorMessage>
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <ErrorDetails>
                {this.state.error.toString()}
                {this.state.errorInfo && (
                  <>
                    {'\n\n'}
                    {this.state.errorInfo.componentStack}
                  </>
                )}
              </ErrorDetails>
            )}
            <ReloadButton onClick={this.handleReload}>
              🔄 {i18n.t('errorBoundary.reload')}
            </ReloadButton>
          </ErrorBox>
        </ErrorContainer>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
